import { render, staticRenderFns } from "./setShelfUserDialog.vue?vue&type=template&id=88c110f4&scoped=true&"
import script from "./setShelfUserDialog.vue?vue&type=script&lang=js&"
export * from "./setShelfUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./setShelfUserDialog.vue?vue&type=style&index=0&id=88c110f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c110f4",
  null
  
)

export default component.exports